// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"334":"33411071","482":"786ea2ca","488":"6330716d"}[chunkId] + ".chunk.js";
};